<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Student Projects</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Student Projects</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="calender ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Project List BBA(CA) </h4>
            <a href="https://drive.google.com/file/d/1sdzWqCiX0VzA75xRGN30suqbN3sHZixZ/view" class="cmn-button"
              target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Project List B.sc(CS)</h4>
            <a href="https://drive.google.com/file/d/1judox8E550yXQxFr7E4Vmyr9l9szp9Zn/view" class="cmn-button"
              target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>B.sc(CS) Project List 2019-20</h4>
            <a href="https://drive.google.com/file/d/19On21itPWQ8SinQPSNVWwee2V_eJr5A8/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>BBA(CA) Project List 2018-19</h4>
            <a href="https://drive.google.com/file/d/1EkiI5ZzBbMSu61VbmaWOTYi0kKKmRdTE/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
